var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:['banner']},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":"首页bannner"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }